import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';

interface Props {
  currenciesData: PortfolioCurrencyBalanceItem[];
}

const PortfolioCurrencyStatisticList: FC<Props> = ({ currenciesData }) => {
  const currencyText = useCurrencyText();

  return (
    <AppCard px="18px">
      {currenciesData.map((data, index) => (
        <Box key={index}>
          <Flex
            display="flex"
            alignItems="center"
            py="15px"
            px="5px"
            justifyContent="space-between"
          >
            <Text>{data.currency.code}</Text>
            <Text>
              {currencyText(data.amount, { symbol: data.currency.symbol })}
            </Text>
          </Flex>
          {index < currenciesData.length - 1 && <Divider />}
        </Box>
      ))}
    </AppCard>
  );
};

export default PortfolioCurrencyStatisticList;
